/**
 * Duyuru çubuğu için kesintisiz kayan bant (marquee) davranışı.
 *
 * Liquid tarafı duyuru metinlerini tek sefer render eder; bu bileşen sayfa
 * yüklendiğinde bu içeriği bir kez daha klonlayıp aynı satırın sonuna ekler.
 * CSS animasyonu (`announcement-marquee-scroll`) şeridi kendi genişliğinin
 * yarısı kadar (-%50) kaydırır — içerik iki kopya olduğu için bu, hiç
 * sıçramadan sonsuz döngü halinde akan bir bant izlenimi verir.
 */
class AnnouncementMarqueeComponent extends HTMLElement {
  connectedCallback() {
    const track = this.querySelector('.announcement-bar__slides');
    if (!track || track.dataset.duplicated === 'true') return;

    const originalSlides = Array.from(track.children);
    if (originalSlides.length === 0) return;

    // Kayan bantta tüm duyurular aynı anda görünür; crossfade moduna özel
    // aria-hidden değerlerini kaldırıyoruz.
    originalSlides.forEach((slide) => slide.removeAttribute('aria-hidden'));

    // İçeriği bir kez daha klonlayıp ekrana okunmasın diye aria-hidden yapıyoruz.
    originalSlides.forEach((slide) => {
      const clone = /** @type {HTMLElement} */ (slide.cloneNode(true));
      clone.setAttribute('aria-hidden', 'true');
      track.appendChild(clone);
    });

    track.dataset.duplicated = 'true';
  }
}

if (!customElements.get('announcement-bar-component')) {
  customElements.define('announcement-bar-component', AnnouncementMarqueeComponent);
}
